import "react-app-polyfill/stable";
import "./dayjs.config";
import "./webmail-logout";

import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sentryUrl } from "config/environment";

import "./locale";
import "./index.css";

const { runConfig } = window;

const SENTRY_ENABLED = runConfig.isSentryEnabled;
const DSN = sentryUrl;

if (SENTRY_ENABLED && DSN) {
  const ENV = runConfig.environment;
  const RELEASE = process.env.REACT_APP_VERSION;

  Sentry.init({
    dsn: DSN,
    environment: ENV,
    release: RELEASE
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
